import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,
} from "reactstrap"

import TablePrimaryComponent from './Components/TablePrimaryComponent'
import moment from "moment"
import DatePicker from '../../../../../helpers/ui/DatePicker'

const IndexView = (props) => {

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")

    const currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    const [filter, setFilter] = useState()
    const [dateStart, setDateStart] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [dateEnd, setDateEnd] = useState(moment().endOf('month').format('YYYY-MM-DD'))

    const activeRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    const handleButtonSearch = () => {
        if (dateStart && dateEnd) {
            setFilter({
                'dateStart': dateStart,
                'dateEnd': dateEnd
            })
            setTimeout(() => {
                reloadActiveRef()
            }, 300);
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        {
                            currentRoleId == 1 &&
                            <div className="float-end">
                                <Link to={`/izinpegawai/dinas.html?list_pegawai`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                        }
                        <CardTitle>Daftar Perjalanan Dinas</CardTitle>
                        <CardSubtitle className="mb-3">
                            Kelola Perjalanan Dinas
                        </CardSubtitle>
                        <hr />
                        <Row className="mb-1">
                            <label className="col-md-3">
                                NIP
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_nip
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Nama
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Jabatan
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_position_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Unit Kerja
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_work_unit_name
                                }
                            </Col>
                        </Row>
                        <hr/>
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Filter Tanggal Mulai
                            </Label>
                            <Col md="3">
                                {/* <Input placeholder="Tanggal Mulai" type="date" onChange={e => setDateStart(e.target.value)} value={dateStart} /> */}
                                <DatePicker 
                                    name="start_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Mulai"
                                    isAvForm={false}
                                    onChange={val => setDateStart(moment(val).format('YYYY-MM-DD'))}
                                    defaultValue={dateStart}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Filter Tanggal Selesai
                            </Label>
                            <Col md="3">
                                {/* <Input placeholder="Tanggal Selesai" type="date" onChange={e => setDateEnd(e.target.value)} value={dateEnd} /> */}
                                <DatePicker 
                                    name="end_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Selesai"
                                    isAvForm={false}
                                    onChange={val => setDateEnd(moment(val).format('YYYY-MM-DD'))}
                                    defaultValue={dateEnd}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md="3"></Col>
                            <Col md="10">
                                <Button 
                                    color="primary" 
                                    type="button"
                                    onClick={() => {
                                        handleButtonSearch()
                                    }}
                                >
                                    <i className="uil-search-alt"></i> Cari
                                </Button>
                            </Col>
                        </Row>

                        <hr/>
                        <TablePrimaryComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} filter={filter} />
                        {/* <Link to="/izinpegawai/dinas.html">
                            <Button color="success">Kembali</Button>
                        </Link> */}
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView